import React from 'react';
import { View, Modal, List, Radio, Flex } from 'antd-mobile';
import lang from 'lodash/lang';
import cx from 'classnames';
import { getStorage } from '../../store/localStorage';
import * as _ from 'lodash';
import { FirstDataCreditCard } from '../first-data';
import { PAYMENT_GATEWAY_STRIPE, PAYMENT_GATEWAY_FIRST_DATA } from '../../constants/app';
import { CardCVCElement, CardExpiryElement, CardNumberElement } from 'react-stripe-elements';
import helpers from 'helpers';
import QrcPayment from '../wechatpay/QrcPayment';

const alert = Modal.alert;
const RadioItem = Radio.RadioItem;

class Dialog extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpenContentDialog: false,
			listItemKeyValue: 0,
			isOpenOperationDialog: false,
			isOpenRemarkDialog: false,
			isOpenCreditCardDialog: false,
      isOpenQrcDialog: false,
      displayQRC: false,
			remarkInputText: '',
			remarkItemOptions: [] // > ??????
    };
    this.handleDisplayQRC = this.handleDisplayQRC.bind(this);

	}

	componentDidMount = () => {
		const { dialogType } = this.props;

		switch (dialogType) {
			case 'confirm':
				this.renderConfirmDialog();
				break;

			case 'warning':
				this.renderWarningDialog();
				break;

			case 'operation':
				this.renderOperationDialog();
				break;

			case 'content':
				this.renderContentDialog();
				break;

			//! HERE
			case 'remark':
				this.updateRemarkItemOptions();
				this.renderRemarkDialog();
				break;

			case 'creditcard':
				this.renderCreditCardDialog();
				break;

			case 'qrc':
				this.renderQrcDialog();
				break;

			default:
				break;
		}
	};

	componentWillUnmount = () => {
		if (this.alertInstance) {
			this.alertInstance.close();
			this.alertInstance = null;
		}
	};

	// > HERE 2
	renderRemarkDialog = () => {
		this.setState({
			isOpenRemarkDialog: true
		});
	};

	// > HERE 1 ??????????????
	updateRemarkItemOptions = async () => {
		const { merchantId } = this.props;
		// > { 9bc083c7-4cb8-4a34-9cff-5cf06ee38eea: [] }
		this.setState({
			remarkItemOptions: _.get(getStorage('remarks'), merchantId, []) // > remarks object in localStorage? pash is merchantId? defalt []?
		});
		// await axios.get(`${baseUrl}/c/remark/list?merchantID=` + merchantId + '&search=' + this.state.remarkInputText + '&limit=5', {
		//   params: {

		//   },
		// }).then(res => {
		//   const tmp = []
		//   const sorted = res.data.sort((a, b) => {
		//     return b.count - a.count
		//   })
		//   sorted.forEach((ele) => {
		//     tmp.push(ele.name)
		//   })
		//   this.setState({
		//     remarkItemOptions: tmp,
		//   })
		// })
	};

	renderWarningDialog = (dialogConfirmBtnText) => {
		const { intl, title, message, triggerModal } = this.props;

		const _title = title || '';
		const _message = message || '';
		const inputs = [];
		if (triggerModal) {
			const _dialogConfirmBtnText = intl.formatMessage({ id: 'dialog.confirm_btn' });

			inputs.push({
				text: _dialogConfirmBtnText,
				onPress: () => {
					triggerModal(true);
				}
			});
		}

		this.alertInstance = alert(_title, _message, inputs);
	};

	renderConfirmDialog = () => {
		const { intl, title, message, triggerModal, confirmBtnText, cancelBtnText, noCancel } = this.props;

		const _dialogConfirmBtnText = confirmBtnText || intl.formatMessage({ id: 'dialog.confirm_btn' });
		const _dialogCancelBtnText = cancelBtnText || intl.formatMessage({ id: 'dialog.cancel_btn' });
		const buttons = [
			{
				text: _dialogConfirmBtnText,
				onPress: () => {
					triggerModal(true);
				}
			}
		];
		if (!noCancel) {
			buttons.unshift({
				text: _dialogCancelBtnText,
				onPress: () => {
					triggerModal(false);
				}
			});
		}
		this.alertInstance = alert(title, message, buttons);
	};

	// > HERE 3
	renderRemarkDialogComponent = () => {
		const {
			title,
			onRemarkItemSelected,
			onCancel,
			intl,
			dishId,
			selectedRemarkItems,
			removePerItemRemark,
			selectedItemIdex,
			orderIdx
		} = this.props;

		const _footer = [];
		if (this.state.remarkInputText !== '') {
			_footer.push({
				text: this.state.remarkInputText,
				onPress: () => {
					onRemarkItemSelected(this.state.remarkInputText, 0);
					this.setState({ remarkInputText: '' });
				}
			});
		}

		// > HIDE
		// this.state.remarkItemOptions.forEach((remark, index) => { // > remarkItemOptions never used??????
		//   _footer.push({
		//     text: remark,
		//     onPress: () => {
		//       onRemarkItemSelected(remark, index + 1)
		//     },
		//   })
		// })

		const remarkPlaceholderText = intl.formatMessage({ id: 'summary.remark.placeholder' }); // 輸入特別要求

		let selectedRemarkItemsDiv;
		if (
			selectedRemarkItems &&
			selectedRemarkItems[selectedItemIdex] &&
			selectedRemarkItems[selectedItemIdex].length > 0
		) {
			const tmp = selectedRemarkItems[selectedItemIdex].map((ele, index) => {
				// > ele === 一個 remark (string)
				return (
					<div
						key={'selected-remark-items-' + index}
						style={{
							color: '#614D4A',
							margin: '4px',
							padding: '4px',
							border: 'solid 1px #ccc',
							display: 'inline-block'
						}}
					>
						{ele}
						<span
							style={{ color: '#C54545' }}
							onClick={() => {
								removePerItemRemark({
									dishId,
									isSetItem: this.props.isSetItem,
									subItemIndex: this.props.subItemIndex,
									remark: ele,
									selectedItemIdex,
									orderIdx: orderIdx
								});
								// > 移除被點擊的 remark
							}}
						>
							&nbsp;X
						</span>
					</div>
				);
			});
			selectedRemarkItemsDiv = <div style={{ margin: '5px', marginBottom: '15px' }}>{tmp}</div>; // > 選擇的備註 container
		}

		return (
			<View>
				<Modal
					prefixCls="am-modal"
					visible={this.state.isOpenRemarkDialog}
					operation
					transparent
					className="am-modal-operation remarks-modal"
					title={title}
					footer={_footer}
					onClose={() => onCancel()}
				>
					{selectedRemarkItemsDiv}
					<input
						placeholder={remarkPlaceholderText}
						style={{
							textAlign: 'center',
							marginBottom: '15px',
							border: 'solid 1px #000',
							borderRadius: '8px',
							height: '30px',
							width: '70%'
						}}
						value={this.state.remarkInputText}
						onChange={(e) => {
							const limitation = 30;
							if (e.target.value.length < limitation) {
								return this.setState(
									{ remarkInputText: e.target.value }
									// () => { this.updateRemarkItemOptions() }, // > HIDE
								);
							}
						}}
					/>
				</Modal>
			</View>
		);
	};

	renderOperationDialogComponent = () => {
		const { title, list, triggerModal, onClose } = this.props;

		const _footer = [];
		list.forEach((item, index) => {
			_footer.push({
				key: 'remark-key-' + index,
				text: item,
				onPress: () => {
					triggerModal(item, index);
				}
			});
		});

		return (
			<Modal
				prefixCls="am-modal"
				visible={this.state.isOpenOperationDialog}
				operation
				transparent
				className="am-modal-operation"
				title={title}
				footer={_footer}
				onClose={() => {
					onClose && onClose();
				}}
			/>
		);
	};

	renderOperationDialog = () => {
		this.setState({
			isOpenOperationDialog: true
		});
	};

	renderContentDialog = () => {
		const { isOpen } = this.props;

		this.setState(
			{
				isOpenContentDialog: isOpen,
				listItemKeyValue: 0
			},
			() => {}
		);
	};

	renderContentDialogComponent = () => {
		const { optionContent, remarkContent, title, intl } = this.props;

		// Intl
		const _dialogConfirmBtnText = intl.formatMessage({ id: 'dialog.confirm_btn' });
		const _dialogCancelBtnText = intl.formatMessage({ id: 'dialog.cancel_btn' });

		const _title = title || '';

		return (
			<Modal
				visible={this.state.isOpenContentDialog}
				transparent
				maskClosable={false}
				title={_title}
				footer={[
					{
						text: _dialogCancelBtnText,
						onPress: () => {
							this.onCloseContentDialog()();
						}
					},
					{
						text: _dialogConfirmBtnText,
						onPress: () => {
							this.confirmContentDialog();
						}
					}
				]}
			>
				<div
					style={{
						height: 300,
						textAlign: 'left'
					}}
				>
					{this.renderContent(optionContent, remarkContent)}
				</div>
			</Modal>
		);
	};
	renderCreditCardDialog = () => {
		const { isOpen } = this.props;
		this.setState(
			{
				isOpenCreditCardDialog: isOpen
			},
			() => {}
		);
	};
	renderQrcDialog = () => {
		const { isOpen } = this.props;
		this.setState(
			{
				isOpenQrcDialog: isOpen
			},
			() => {}
		);
	};
	handleUpdateCardHolder = (e) => {
		this.setState({ cardHolder: e.target.value });
	};
	handleCardNumberChanged = (event) => {
		this.setState({
			isCardNumComplete: event.complete
		});
	};

	handleCardExpireDateChanged = (event) => {
		this.setState({
			isCardExpireDateComplete: event.complete
		});
	};

	handleCardCVCChanged = (event) => {
		this.setState({
			isCardCVCComplete: event.complete
		});
	};
	payWithCreditCardInfo = async () => {
		const { stripe, intl } = this.props;
		if (stripe) {
			this.setState({ isSubmittingPayment: true });
			try {
				const payload = await stripe.createToken({
					name: this.state.cardHolder
				});
				if (_.get(payload, 'error')) {
					throw payload.error;
				}
				if (!payload || !payload.token) {
					throw new Error('invalid token');
				}
				await this.submitByPayToken(payload.token.card.brand, payload.token.id);
			} catch (err) {
				console.error(err);
				let errMsg = intl.formatMessage({ id: 'error.general' });
				const errCode = _.get(helpers.json.parse(_.get(err, 'data.error')), 'code');
				if (errCode) {
					const msg = intl.formatMessage({ id: 'error.stripe.' + errCode });
					if (msg !== 'error.stripe.' + errCode) {
						errMsg = msg;
					}
					this.setState({
						isSubmittingPayment: false,
						isRenderToast: true,
						toastMessage: errMsg
					});
				}
			}
		}
	};
	submitByPayToken = async (paymentType, token) => {
		const { submit } = this.props;
		// Card brand. Can be American Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown.
		const paymentTypeMap = {
			'American Express': 'ae',
			'Diners Club': 'diners_club',
			JCB: 'jcb',
			MasterCard: 'master',
			UnionPay: 'unionpay',
			Visa: 'visa',
			Unknown: 'unknown'
		};
		const payment = paymentTypeMap[paymentType] ? paymentTypeMap[paymentType] : 'unknown';
		return submit({ payment, source: token, gateway: PAYMENT_GATEWAY_STRIPE });
	};
	renderCreditCardDialogComponent = () => {
		const { onClose, intl, classes, submit, optionHeading, paymentGateway, amount } = this.props;
		const _cardNumPlaceholderText = intl.formatMessage({ id: 'takeaway.summary.cardnum_placeholder' });
		const _cardHolderPlaceholderText = intl.formatMessage({ id: 'takeaway.summary.cardholder_placeholder' });
		const _cardExpirationPlaceholderText = intl.formatMessage({
			id: 'takeaway.summary.card_expiration_placeholder'
		});
		const _payText = intl.formatMessage({ id: 'footer.takeaway.confirm.pay' });
		const _cardCVVPlaceholderText = intl.formatMessage({ id: 'takeaway.summary.ccv_placeholder' });
		const _reorderText = intl.formatMessage({ id: 'takeaway.reorder' });
		const _paymentText = intl.formatMessage({ id: 'checkout.hand.up.pay' });

		const telInputStyle = cx(classes['dinein-credit-card-tel-input']);
		const selectStyle = cx(classes['dinein-credit-card-select']);
		const paymentOptionStyle = cx(classes['payment-option']);
		const validStyle = cx(classes['dinein-credit-card-footer']);
		const invalidStyle = cx(classes['dinein-credit-card-footer-invalid']);
		const totalStyle = cx(classes['dinein-credit-card-title']);

		const cardPlaceholder = {
			card: _cardNumPlaceholderText,
			name: _cardHolderPlaceholderText,
			exp: _cardExpirationPlaceholderText,
			cvv: _cardCVVPlaceholderText,
			pay: _payText
		};

		const formStyle = {
			paymentOptionStyle,
			telInputStyle,
			selectStyle,
			validStyle,
			invalidStyle
		};

		let option;

		const valid =
			this.state.isCardNumComplete &&
			this.state.isCardExpireDateComplete &&
			this.state.isCardCVCComplete &&
			!this.state.isSubmittingPayment;

		const footerStyle = valid
			? cx(classes['dinein-credit-card-footer'])
			: cx(classes['dinein-credit-card-footer-invalid']);

		const reorderStyle = cx(classes['takeaway-summary-reorder-btn']);

		switch (paymentGateway) {
			case PAYMENT_GATEWAY_FIRST_DATA:
				option = (
					<FirstDataCreditCard
						optionHeading={optionHeading}
						cardPlaceholder={cardPlaceholder}
						formStyle={formStyle}
						amount={amount}
						submit={submit}
					/>
				);
				break;
			case PAYMENT_GATEWAY_STRIPE:
			default:
				option = (
					<div>
						{optionHeading}
						<div className={paymentOptionStyle} style={{ height: '300px' }}>
							{/* Card Number */}
							<CardNumberElement
								className={telInputStyle}
								onChange={this.handleCardNumberChanged}
								placeholder={_cardNumPlaceholderText}
							/>

							{/* Card Holder */}
							<input
								className={telInputStyle}
								placeholder={_cardHolderPlaceholderText}
								onChange={this.handleUpdateCardHolder}
							/>

							<Flex style={{ overflow: 'visible' }}>
								{/* Expired Date */}
								<Flex.Item>
									<CardExpiryElement
										className={selectStyle}
										onChange={this.handleCardExpireDateChanged}
										placeholder={_cardExpirationPlaceholderText}
									/>
								</Flex.Item>

								{/* CVC */}
								<Flex.Item>
									<CardCVCElement
										className={selectStyle}
										onChange={this.handleCardCVCChanged}
										placeholder={_cardCVVPlaceholderText}
									/>
								</Flex.Item>
							</Flex>

							{/* Pay Button */}
							<div className={footerStyle} onClick={valid ? this.payWithCreditCardInfo : null}>
								{_payText}
							</div>
							{this.state.isShowReorderBtn && (
								<div
									className={reorderStyle}
									onClick={() => {
										const { history } = this.props;
										const path = '/home';
										history.push(path);
										console.info('route changed', path);
										this.setState({ paymentMethod: null });
									}}
								>
									{_reorderText}
								</div>
							)}
						</div>
					</div>
				);
				break;
		}

		return (
			<Modal
				prefixCls="am-modal"
				visible={this.state.isOpenCreditCardDialog}
				className="am-modal-operation"
				transparent
				popup
				animationType="slide-up"
				onClose={() => {
					onClose && onClose();
				}}
			>
				<div style={{ overflow: 'scroll', padding: '0 20px' }}>
					<div className={totalStyle}>{`${_paymentText} $ ${amount}`}</div>
					{option}
				</div>
			</Modal>
		);
  };
  handleDisplayQRC = () => {
		this.setState({ displayQRC: !this.state.displayQRC });
	};
  renderQrcDialogComponent = () => {
    const {
      submit,
      qrcode,
      outTradeNo,
      optionHeading,
      onClose,
      syssn,
    } = this.props
		return (
      <Modal
        prefixCls="am-modal"
        visible={this.state.isOpenQrcDialog}
        className="am-modal-operation"
        transparent
        popup
        animationType="slide-up"
        onClose={() => {
          onClose && onClose()
        }}
      >
        <div style={{ overflow: "scroll", padding: "0 20px" }}>
          <QrcPayment
            syssn={syssn}
            submit={submit}
            handleDisplayQRC={this.handleDisplayQRC}
            optionHeading={optionHeading}
            wechatQRC={qrcode}
            orderID={outTradeNo}
          />
          ‰
        </div>
      </Modal>
    )
	};
	renderContent = (optionContent, remarkContent) => {
		const { contentType } = this.props;

		switch (contentType) {
			case 'options':
				return this.renderOptionsContent(optionContent, remarkContent);

			default:
		}
	};

	renderOptionsContent = (optionContent, remarkContent) => {
		const { intl, classes } = this.props;

		const optionDivNone = intl.formatMessage({ id: 'dialog.option_div_none' });
		const listWrapStyle = cx(classes['list-wrap']);
		if (lang.isArray(optionContent)) {
			const _list = optionContent.map((optionItem, optionItemKey) => {
				let optiondDiv;
				let optionName;
				let remarkName;

				if (
					optionItem.length !== 0 ||
					(remarkContent[optionItemKey] && remarkContent[optionItemKey].length !== 0)
				) {
					optionName = optionItem.reduce((result, item, itemKey) => {
						if (itemKey !== 0) {
							return result + ', ' + item.name;
						} else {
							return item.name;
						}
					}, '');

					remarkName = ((remarkContent && remarkContent[optionItemKey]) || [])
						.reduce((result, item, itemKey) => {
							if (itemKey !== 0) {
								return result + ', ' + item;
							} else {
								return item;
							}
						}, '');

					optionName = optionName === '' ? '-' : optionName;
					// tmp = remarkContent[optionItemKey].reduce((item, result, itemKey) => {
					//     return result + item;
					// }, tmp);
					// optionName = tmp;
					// = optionItem.map((item, itemKey) => {
					//     return (
					//         <div style={{ width: 'calc(100% - 30px)', textOverflow: 'ellipsis', overflow: 'hidden' }}
					//             className="list-item"
					//             key={itemKey} >
					//             {item.name}
					//         </div>
					//     )
					// });
					optiondDiv = (
						<div>
							<div>{optionName}</div>
							<div style={{ fontSize: '11px' }}>{remarkName}</div>
						</div>
					);
				} else {
					optiondDiv = <div>{optionDivNone}</div>;
				}
				return (
					<RadioItem
						key={optionItemKey}
						checked={this.state.listItemKeyValue === optionItemKey}
						onChange={() => this.onRadioItemChange(optionItem, optionItemKey)}
					>
						{optiondDiv}
					</RadioItem>
				);
			});

			return (
				<List>
					<div className={listWrapStyle}>{_list}</div>
				</List>
			);
		}
	};

	onCloseRemarkDialog = () => {
		// const {
		// triggerItemOptionsOverlayEvent
		// } = this.props;
		this.setState(
			{
				isOpenRemarkDialog: false
			},
			() => {
				// triggerItemOptionsOverlayEvent();
			}
		);
	};

	onCloseContentDialog = (key) => () => {
		const { triggerItemOptionsOverlayEvent } = this.props;

		this.setState(
			{
				isOpenContentDialog: false
			},
			() => {
				triggerItemOptionsOverlayEvent();
			}
		);
	};

	onRadioItemChange = (data, index) => {
		this.setState({
			listItemKeyValue: index
		});
	};

	confirmContentDialog = () => {
		const { confirmButtonAction } = this.props;

		this.setState(
			{
				isOpenContentDialog: false
			},
			() => {
				confirmButtonAction(this.state.listItemKeyValue);
			}
		);
	};

	render() {
		return (
			<React.Fragment>
				{this.state.isOpenContentDialog && this.renderContentDialogComponent()}
				{this.state.isOpenOperationDialog && this.renderOperationDialogComponent()}
				{this.state.isOpenRemarkDialog && this.renderRemarkDialogComponent()}
				{this.state.isOpenCreditCardDialog && this.renderCreditCardDialogComponent()}
				{this.state.isOpenQrcDialog && this.renderQrcDialogComponent()}
			</React.Fragment>
		);
	}
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/hoc/Dialog.js